import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AllCities, AllHospitals, UhidRequest, UhidResponse } from '../models/common-model';
import { BookHealthCheck, BookHealthCheckRes, DatesObj, HealthCheckTypes, SlotTimeData, SlotTimeV2 } from '../models/health-check-types.model';
import { BookcorpHealthCheckAppt,BookcorpHealthCheckApptRes } from '../models/book-corp-healthcheck.model';

@Injectable({
  providedIn: 'root'
})
export class HealthCheckService {

  headers = new HttpHeaders().set('xauthtoken', environment.askapolloApiKey);
  constructor(
    private http: HttpClient
  ) { }


  /* 
    @API     api/AHLLCRM/GetAllCities
    @Desc    To Get Health Check Cities
    @Method  POST
  */
  getCities(): Observable<AllCities> {
    let request = {
      "appointmentTypeId": 3,
      "hospitalTypeId": 2
    }
    return this.http.post<AllCities>(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllCities`, request, { headers: this.headers })
  }


  /* 
    @API     api/AHLLCRM/GetHospitalsOrClinicsByCityId
    @Desc    To Get Health Check Clinics by City Id
    @Method  POST
  */
  getHospitals(cityId: number, appointmentType: number): Observable<AllHospitals> {
    let request = {
      "appointmentTypeId": (appointmentType ? appointmentType : 1),
      "hospitalTypeId": 2,
      "cityId": cityId
    }
    return this.http.post<AllHospitals>(`${environment.askapolloAPiURL}api/AHLLCRM/GetHospitalsOrClinicsByCityId`, request, { headers: this.headers })
  }

  // @API     api/AHLLCRM/GetAllHealthChecksByHospitalId
  // @Desc    Get Health checks based on Hospital Id, Age and Gender
  // @Method  POST
  getHealthChecksBasedOnHospitalId(data: any): Observable<HealthCheckTypes> {
    return this.http.post<HealthCheckTypes>(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllHealthChecksByHospitalId`, data, { headers: this.headers });
  }

  // @API     api/AHLLCRM/GetHealthChecksByHospitalIdv2
  // @Desc    Get Health checks based on Hospital Id, Age and Gender
  // @Method  POST
  GetHealthChecksByHospitalIdv2(data: any): Observable<HealthCheckTypes> {
    return this.http.post<HealthCheckTypes>(`${environment.askapolloAPiURL}api/AHLLCRM/GetHealthChecksByHospitalIdv3`, data, { headers: this.headers });
  }

  // @API     api/AHLLCRM/GetUHIDListUsingUHIDorMobileNumberorEmailFromPrismV2
  // @Desc    Get UHIDs from prism using mobile no
  // @Method  POST
  getUserDetailsBasedOnMobileOrUHID(data: UhidRequest): Observable<UhidResponse> {

    return this.http.post<UhidResponse>(`${environment.askapolloAPiURL}api/AHLLCRM/GetUHIDListUsingUHIDorMobileNumberorEmailFromPrismV2`, data, { headers: this.headers })
  }

  // @API     api/AHLLCRM/GetUHIDListUsingUHIDorMobileNumberorEmailFromPrismV2
  // @Desc    Get UHID details from prism using UHID
  // @Method  POST
  getUserDetailsBasedOnMobileOrUHIDFromPrism(data: UhidRequest): Observable<UhidResponse> {
    return this.http.post<UhidResponse>(`${environment.askapolloAPiURL}api/AHLLCRM/GetUHIDListUsingUHIDorMobileNumberorEmailFromPrismV2`, data, { headers: this.headers })
  }

  // @API     api/AHLLCRM/GetAvailableHealthCheckDatesIneDocv3
  // @Desc    Get Health check dates based on Health Check Id and Hospital Id
  // @Method  POST
  getHealthCheckDates(data: any): Observable<DatesObj> {
    return this.http.post<DatesObj>(`${environment.askapolloAPiURL}api/AHLLCRM/GetAvailableHealthCheckDatesIneDocv3`, data, { headers: this.headers });
  }

  // @API     api/AHLLCRM/GetAvailableHealthCheckSlotsIneDocv3
  // @Desc    Get Health check slots based on Health Check Id and Hospital Id and selected Date
  // @Method  POST
  getHealthCheckSlots(data: any): Observable<SlotTimeData[]> {
    return this.http.post<SlotTimeData[]>(`${environment.askapolloAPiURL}api/AHLLCRM/GetAvailableHealthCheckSlotsIneDocv3`, data, { headers: this.headers });
  }

  getBookHealthCheck(payload) {
    return this.http.put(environment.apiUrl + 'HealthCheck/InsertHealthcheckDetails', payload);
  }

  getUpdateHealthCheck(key, payload) {
    return this.http.post(`${environment.apiUrl}HealthCheck/UpdateHealthCheckDetails/${key}`, payload);
  }
  // @API     api/AHLLCRM/BookHealthCheckAppointmentIneDocv3
  // @Desc    Book the health check for selected health check package
  // @Method  POST
  bookHealthCheck(data: any, authToken:string): Observable<BookHealthCheckRes> {
    // this.headers = new HttpHeaders().set('Authorization', "Bearer "+authToken);   
    localStorage.setItem("HC_JWT_TOKEN", authToken);
    this.headers = new HttpHeaders().set('xauthtoken', environment.askapolloApiKey);     
    return this.http.post<BookHealthCheckRes>(`${environment.askapolloAPiURL}api/AHLLCRM/BookHealthCheckAppointmentIneDocv3`, data, { headers: this.headers });
  }

  // @API     api/AHLLCRM/GetAllCorporateHCCustomers
  // @Desc    To get all the corporate customers
  // @Method  POST
  getCorporateHealthCheckCustomers(data : any) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllCorporateHCCustomers`, data, { headers: this.headers });
  }

  // @API     api/AHLLCRM/GetAllCorporateHCCustomers
  // @Desc    To get all the corporate agreements
  // @Method  POST
   GetAllCorporateHCAgreements(customerName) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllCorporateHCAgreements`, customerName, { headers: this.headers });
  }

   // @API     api/AHLLCRM/GetAllCorporateHCPackages
   // @Desc    To get all the corporate agreements
   // @Method  POST
  GetAllCorporateHCPackages(agreementName) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllCorporateHCPackages`, agreementName, { headers: this.headers });
  }

   // @API     api/AHLLCRM/GetAllCorporateHCCities
   // @Desc    To get all the corporate cites
   // @Method  POST
   GetAllCitieseForHCCorp(data) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllCorporateHCCities`, data, { headers: this.headers });
  }

    // @API     api/AHLLCRM/GetAllCorporateHCHospitalsByCityId
    // @Desc    To get all the corporate health check hospitals
   // @Method  POST
   GetAllCorporateHcHospitalsByCityId(cityId) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllCorporateHCHospitalsByCityId`, cityId, { headers: this.headers });
  }

     // @API     api/AHLLCRM/GetAvailableCorporateHCSlotsBySearchCriteria
    // @Desc    To get all the avaailable slots
   // @Method  POST
   GetAllAvailableSlots(data) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/GetAvailableCorporateHCSlotsBySearchCriteria`, data, { headers: this.headers });
  }

     // @API    api/AHLLCRM/BookCorporateHCAppointmentIneDoc
    // @Desc    Book health appointment for health check corporation
   // @Method  POST
   BookApptHCCorp(data : BookcorpHealthCheckAppt) : Observable<BookcorpHealthCheckApptRes> {
    return this.http.post<BookcorpHealthCheckApptRes>(`${environment.askapolloAPiURL}api/AHLLCRM/BookCorporateHCAppointmentIneDoc`, data, { headers: this.headers });
  }

  InsertBookApptHCCorp(payload: any) {
    return this.http.put<any>(`${environment.apiUrl}CorporateHealthCheck/InsertCorpHealthcheckDetails`, payload, { headers: this.headers });
  }

  UpdateBookApptHCCorp(key, payload: any) {
    return this.http.post<any>(`${environment.apiUrl}CorporateHealthCheck/UpdateCorpHealthCheckDetails/${key}`, payload);
  }

    // @API    api/AHLLCRM/GetAllHealthCheckAppointmentsForDashboardForCRM
    // @Desc    GetAllHealthCheckAppointmentsForDashboardForCRM for health check corporation
   // @Method  POST
  getHCAppointmentsHistoryOnMobileNumber(payload: any){
    return this.http.post<BookcorpHealthCheckApptRes>(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllHealthCheckAppointmentsForDashboardForCRM`, payload, { headers: this.headers });
  }

   // @API    api/AHLLCRM/RescheduleHealthCheckAppointmentv2
    // @Desc    RescheduleHealthCheckAppointmentv2 for health check corporation
   // @Method  POST
   getHCAppointmentsReschedule(payload: any){
    return this.http.post<any>(`${environment.askapolloAPiURL}api/AHLLCRM/RescheduleHealthCheckAppointmentv2`, payload, { headers: this.headers });
  }

   // @API    api/AHLLCRM/CancelHealthCheckAppointmentIneDocv2
    // @Desc    CancelHealthCheckAppointmentIneDocv2 for health check corporation
   // @Method  POST
   getHCAppointmentsCancel(payload: any){
    return this.http.post<any>(`${environment.askapolloAPiURL}api/AHLLCRM/CancelHealthCheckAppointmentIneDocv2`, payload, { headers: this.headers });
  }

     // @API    api/AHLLCRM/GetAllCorporateHealthCheckAppointmentsForCRM
    // @Desc    To get all corporate health check appointment history by mobile number
   // @Method  POST
  getCorporateAppointmentsHistoryOnMobileNumberFromAskApollo(payload: any) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/GetAllCorporateHealthCheckAppointmentsForCRM`, payload, { headers: this.headers });
  }

     // @API    api/AHLLCRM/RescheduleCorporateHCAppointmentIneDoc
    // @Desc    Reschedule Corporate HC Appointment
   // @Method  POST
   RescheduleCorporateHCAppointment(payload: any) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/RescheduleCorporateHCAppointmentIneDoc`, payload, { headers: this.headers });
  }

     // @API    api/AHLLCRM/CancelCorporateHCAppointmentIneDoc
    // @Desc    Cancel Corporate HC Appointment
   // @Method  POST
   CancelCorporateHCAppointment(payload: any) {
    return this.http.post(`${environment.askapolloAPiURL}api/AHLLCRM/CancelCorporateHCAppointmentIneDoc`, payload, { headers: this.headers });
  }

}
